import { css } from '@emotion/react';
import { Box, styled } from '@mui/joy';
import { createFileRoute, Link, Outlet, ScrollRestoration } from '@tanstack/react-router';

import LKWLogo from '@/assets/icons/lkw-lotse.svg?react';
import { Footer } from '@/components/Footer';
import { HeaderList } from '@/components/navigations/HeaderList';
import { HeaderListItemButton } from '@/components/navigations/HeaderListItemButton';
import { MAIN_BREAKPOINT } from '@/modules/MAIN_BREAKPOINT';

const Root = styled(Box)(
  () => css`
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  `,
);

const LegalWrapper = styled(Box)(
  ({ theme }) => css`
    padding: ${theme.spacing(4)} ${theme.spacing(3)};

    ${theme.breakpoints.up(MAIN_BREAKPOINT)} {
      padding: ${theme.spacing(6)} ${theme.spacing(12)};
    }
  `,
);

const HeaderLogoWrapper = styled(Box)(
  ({ theme }) => css`
    display: flex;
    justify-content: center;

    ${theme.breakpoints.up(MAIN_BREAKPOINT)} {
      display: none;
    }
  `,
);

const Header = styled(Box)(
  ({ theme }) => css`
    position: sticky;
    top: 0;
    z-index: 1100;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: ${theme.palette.common.white};
    box-shadow: 0 3px 6px #00000029;
    padding: ${theme.spacing(2)} ${theme.spacing(3)};
    flex-direction: row-reverse;
    gap: ${theme.spacing(2)};

    ${theme.breakpoints.up(MAIN_BREAKPOINT)} {
      display: grid;
      grid-template-columns: 2fr 1fr 2fr;

      padding: ${theme.spacing(2)} ${theme.spacing(12)};
    }
  `,
) as typeof Box;

const FooterWrapper = styled(Box)(
  ({ theme }) => css`
    margin-top: auto;
    padding-bottom: ${theme.spacing(2)};

    ${theme.breakpoints.up(MAIN_BREAKPOINT)} {
      padding: 0;
    }
  `,
);

function LegalLayout() {
  return (
    <Root>
      <Header component="header">
        <HeaderList>
          <HeaderListItemButton component={Link} to="/">
            Startseite
          </HeaderListItemButton>
        </HeaderList>
        <HeaderLogoWrapper>
          <Link to="/">
            <LKWLogo />
          </Link>
        </HeaderLogoWrapper>
      </Header>
      <LegalWrapper>
        <ScrollRestoration />
        <Outlet />
      </LegalWrapper>
      <FooterWrapper>
        <Footer />
      </FooterWrapper>
    </Root>
  );
}

export const Route = createFileRoute('/_legal')({
  component: LegalLayout,
});
